import { render, staticRenderFns } from "./CreditsListItemImgItem.vue?vue&type=template&id=06ededb5&scoped=true&"
import script from "./CreditsListItemImgItem.vue?vue&type=script&lang=js&"
export * from "./CreditsListItemImgItem.vue?vue&type=script&lang=js&"
import style0 from "./CreditsListItemImgItem.vue?vue&type=style&index=0&id=06ededb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ededb5",
  null
  
)

export default component.exports